/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Swedish
export default {
  'navigation.global-shortcuts.all-sites': 'Alla webbplatser',
  'navigation.global-shortcuts.apps.align': 'Justera',
  'navigation.global-shortcuts.apps.analytics': 'Analysverktyg',
  'navigation.global-shortcuts.apps.assets': 'Tillgångar',
  'navigation.global-shortcuts.apps.bitbucket': 'Bitbucket',
  'navigation.global-shortcuts.apps.company-hub': 'Företagsnav',
  'navigation.global-shortcuts.apps.compass': 'Compass',
  'navigation.global-shortcuts.apps.confluence': 'Confluence',
  'navigation.global-shortcuts.apps.focus': 'Fokus',
  'navigation.global-shortcuts.apps.goals': 'Mål',
  'navigation.global-shortcuts.apps.home': 'Hem',
  'navigation.global-shortcuts.apps.jira': 'Jira',
  'navigation.global-shortcuts.apps.jira-product-discovery': 'Jira Product Discovery',
  'navigation.global-shortcuts.apps.jira-service-management': 'Jira Service Management',
  'navigation.global-shortcuts.apps.loom': 'Loom',
  'navigation.global-shortcuts.apps.opsgenie': 'Opsgenie',
  'navigation.global-shortcuts.apps.projects': 'Projekt',
  'navigation.global-shortcuts.apps.studio': 'Studio',
  'navigation.global-shortcuts.apps.talent': 'Talent',
  'navigation.global-shortcuts.apps.teams': 'Team',
  'navigation.global-shortcuts.apps.trello': 'Trello',
  'navigation.global-shortcuts.menu-expand-item.close-button-aria-label': 'Stäng',
  'navigation.global-shortcuts.menu-expand-item.site-aria-label': 'Webbplatsen {name}',
  'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label': '(inte tillgänglig just nu)',
  'navigation.global-shortcuts.menu-link-item.link-external-item-label': 'Öppna ikonen för extern länk',
  'navigation.global-shortcuts.menu-link-item.loading-item-aria-label': '(läser in)',
  'navigation.global-shortcuts.menu-loading-item.loading-item-aria-label': '(läser in)',
  'navigation.global-shortcuts.shortcut-action.open-menu-label': 'öppna menyn',
  'navigation.global-shortcuts.sites': '{productName}-webbplatser',
};
